<template>
  <div class="pagina-step">
    <span class="pagina-step-title"
      >Quantos médicos de coparticipação no Mais Médicos o município tem?</span
    >
    <div class="container-form">
      <ValidationObserver ref="observer" class="row">
        <div class="col-md-2 col-12">
          <validation-provider
            v-slot="{ errors }"
            rules="required"
            ref="validationMedicos"
          >
            <div>
              <input
                name="medicos"
                v-model="form.medicos"
                class="form-control"
                placeholder=""
                type="text"
                v-inputmask="maskNumbers"
              />
            </div>
            <div class="error">{{ errors[0] }}</div>
          </validation-provider>
        </div>
      </ValidationObserver>
    </div>
    <div class="container-buttons">
      <button type="button" @click="voltar">Voltar</button>
      <button @click="proximo">Avançar</button>
    </div>
  </div>
</template>

<script>
import PulseLoader from 'vue-spinner/src/PulseLoader.vue'
import VueSelect from 'vue-select'
import 'vue-select/dist/vue-select.css'
import { ValidationObserver, ValidationProvider } from 'vee-validate'
import { validations } from '@/mixins/validations'
validations()
import Masks from '@/mixins/masks'

export default {
  components: {
    PulseLoader,
    'vue-select': VueSelect,
    ValidationObserver,
    ValidationProvider,
  },
  props: {
    dados: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      form: {
        medicos: '',
      },
      loading: false,
    }
  },
  mounted() {
    if (this.dados?.etapa7 !== null) {
      const etapa7 = this.dados?.etapa7
      this.form.medicos = etapa7.medicos
    }
  },
  computed: {
    maskNumbers() {
      return Masks['number']
    },
  },
  methods: {
    salvarDados() {
      this.$emit('dados-etapa', { etapa: 'etapa7', dados: this.form })
    },

    voltar() {
      this.$emit('etapa-anterior')
    },

    proximo() {
      this.$refs.observer.validate().then(async (success) => {
        if (success) {
          try {
            this.loading = true
            this.salvarDados()
            this.$emit('proxima-etapa')
          } catch (error) {
            console.log(error)
          } finally {
            this.loading = false
          }
        } else {
          this.$toast.warning('Preencha os campos obrigatórios!', 'Erro:', {
            position: 'topRight',
          })
        }
      })
    },
  },
}
</script>
<style scoped lang="scss" src="./styles.scss" />
